import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LorenGeofencingShape } from "../../interfaces/loren-geofencing-shape.interface";
import { LorenBreakpointObserverService } from "../../../../shared/services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import { LorenGeofencingShapes } from "../../constants/loren-geofencing-shapes.constants";

@Component({
    selector: "loren-loren-shape-creation-dialog",
    templateUrl: "./loren-shape-creation-dialog.component.html",
    styleUrls: ["./loren-shape-creation-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenShapeCreationDialogComponent {
  private data = inject<LorenGeofencingShape>(MAT_DIALOG_DATA);
  protected breakpointObserverService = inject(LorenBreakpointObserverService);

  selectedShape: number;
  isHandset: boolean;

  shapes: LorenGeofencingShape[] = LorenGeofencingShapes;

  constructor() {
    this.breakpointObserverService
      .getHandsetStateSubscription()
      .subscribe((res) => (this.isHandset = res));
  }

  save() {
    this.data.type = this.shapes[this.selectedShape].type;
  }

  selectShape(index: number) {
    this.selectedShape = index;
  }
}
